/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import * as Sentry from '@sentry/react';

// sentry initialization
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 0.2,
  tracePropagationTargets: JSON.parse(import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS
    || '["https://portal-dev.hellolunajoy.com"]'),
  environment: import.meta.env.VITE_ENV,
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',
});

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
  </BrowserRouter>
  );
}

// If the root element is not found, log an error
else {
  console.error('Root element not found');
}
